import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var SettingsHttpService = /** @class */ (function () {
    function SettingsHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    SettingsHttpService.prototype.getRegions = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-regions';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getDispenseMode = function (machine_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-vend-mode/' + machine_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getCupDrop = function (machine_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-cup-drop/' + machine_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log("Get Cup Drop: ", err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getFetchFileTypes = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/fetch-file-type';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.remoteFetchFiles = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/fetch-log';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.remoteOutOfOrder = function (content) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/remote-ooorder';
            var params = {
                body: content
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.remoteVouchers = function (content) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/remote-vouchers';
            var params = {
                body: content
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.changeVendMode = function (content) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/vend-mode';
            var params = {
                body: content
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getFreeVendMode = function (machine_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-free-vend-mode/' + machine_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.changeFreeVendMode = function (content) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/free-vend-mode';
            var params = {
                body: content
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.changeCupDrop = function (content) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/cup-drop';
            var params = {
                body: content
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result.data);
            }).catch(function (err) {
                console.log("CUP DROP", err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getTerritories = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-territories';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getInCompVersions = function (comp) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/incompatibles';
            var params = {
                body: {
                    comp: comp
                }
            };
            API.post(_this.apiName, path, params).then(function (lists) {
                var verArray = [];
                for (var _i = 0, lists_1 = lists; _i < lists_1.length; _i++) {
                    var list = lists_1[_i];
                    verArray.push(list.file_version);
                }
                observer.next(verArray);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getMachineDet = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_machine_info/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getCampusLocation = function (campus_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-camp/' + campus_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(observer.err);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getCalibSettings = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-calib-settings/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getMachineSettings = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-settings/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getPriceChange = function (machine_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/price_change/' + machine_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateMenuPrices = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/price_change';
            var params = {
                body: formObj
            };
            API.put(_this.apiName, path, params).then(function (res) {
                observer.next(res.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getShadowData = function (serial_no) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-shadow-data/' + serial_no;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateMachineSettings = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/update-settings';
            var params = {
                body: formObj
            };
            API.put(_this.apiName, path, params).then(function (res) {
                observer.next(res);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateMachineDet = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/update_mac_info';
            var params = {
                body: formObj
            };
            API.put(_this.apiName, path, params).then(function (res) {
                observer.next(res);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getVersion = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_curr_versions/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data[0]);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getAllFiles = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_files_list';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getCACodes = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_ca_status_dict';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (ca_codes) {
                var result = {};
                for (var _i = 0, ca_codes_1 = ca_codes; _i < ca_codes_1.length; _i++) {
                    var code = ca_codes_1[_i];
                    result[code.ca_code] = code.code_details;
                }
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.assignLink = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/assign_link';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getMachineKeys = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_setting/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (keys) {
                observer.next(keys[0]);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getMachineConnState = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/conn-status/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (status) {
                observer.next(status.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.remoteReboot = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/remote_reboot/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (result) {
                observer.next(result);
                console.log("Result", result);
            }).catch(function (err) {
                console.log(err.response);
                // console.log("Error", err)
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateMacKeys = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/save_settings_web';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.testVend = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/remote_test_vend';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.testPrint = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/remote_test_print';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateMacKeysMulti = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/machineKeys';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getMacConnLogs = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_mac_conn_log/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.deleteCoil = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/delete_coil';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.updateCoilDet = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            console.log(formObj);
            var path = '/dashboard/update_coil_details';
            var params = {
                body: [formObj]
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.send2machineLater = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/update_coildet_shadow';
            var params = {
                body: { obj: formObj }
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.send2machine = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/snd_coil_details';
            var params = {
                body: { m_id: m_id }
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.prototype.getCoilDets = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_coil_dets/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (coil_dets) {
                console.log(coil_dets);
                var result = [];
                var coils = [];
                for (var _i = 0, coil_dets_1 = coil_dets; _i < coil_dets_1.length; _i++) {
                    var coil = coil_dets_1[_i];
                    var ind = coils.indexOf(coil.tray_id);
                    if (ind > -1) {
                        result[ind].details.push(coil);
                    }
                    else {
                        coils.push(coil.tray_id);
                        result.push({
                            tray_id: coil.tray_id,
                            details: [coil]
                        });
                    }
                }
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SettingsHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingsHttpService_Factory() { return new SettingsHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: SettingsHttpService, providedIn: "root" });
    return SettingsHttpService;
}());
export { SettingsHttpService };
